export const PageIds = {
  PREVIEW: 3,
  INVOICING: 4,
  CONSUMPTION: 5,
  PEOPLE: 6,
  DEPRECIATION: 7,
  OTHER_EXPENSES: 8,
  USERS: 9,
  ACCESS_PROFILE: 15
} as const

export interface SideBarDataProps {
  id: number
  icon: string
  name: string
  isActive: boolean
  path: string
  children: SideBarDataProps[]
}

export interface FieldsPersistedDataProps {
  competenceDate?: string | number | null
  competencePeriod?: string | number | null
  profitCenter?: string | number | null
}

export interface UseLayoutProps {
  fieldsPersistedData: FieldsPersistedDataProps | null
  setFieldsPersistedData: (value: FieldsPersistedDataProps | null) => void

  sideBarData: SideBarDataProps[]
  setSideBarData: (value: SideBarDataProps[]) => void

  isSideBarDataLoading: boolean
  setIsSideBarDataLoading: (value: boolean) => void

  isMenuOpen: boolean
  setIsMenuOpen: (value: boolean) => void

  isMenuCollapsedPersisted: boolean | null
  setIsMenuCollapsedPersisted: (value: boolean | null) => void

  getSideBarData: () => Promise<void>
}
